import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { matchesAPI } from '../utils/api';
import MatchCard from '../components/MatchCard';

export default function HomePage() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    matchesAPI.getAll({ status: 'upcoming' }).then(res => {
        let data = Array.isArray(res?.data) ? res.data : (res?.data?.matches || []);
        setMatches(data.slice(0, 6));
      }).catch(() => setMatches([])).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ background: '#020205', minHeight: '100vh', color: '#fff', fontFamily: 'Outfit, sans-serif' }}>
      <style>{`
        * { box-sizing: border-box; }
        
        .container {
          padding: 40px 20px;
          max-width: 1200px;
          margin: 0 auto;
          width: 100%;
        }

        .match-grid {
          display: grid;
          gap: 24px;
          grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
        }

        @media (min-width: 768px) {
          .match-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (min-width: 1024px) {
          .match-grid { grid-template-columns: repeat(3, 1fr); }
        }

        .hero-title {
          font-size: clamp(50px, 12vw, 90px);
          line-height: 0.9;
          margin-bottom: 20px;
          letter-spacing: 0.02em;
        }
        
        .glow-btn {
          display: inline-block; padding: 16px 36px; background: linear-gradient(90deg, #0055FF, #00E5FF); 
          color: #fff; text-decoration: none; border-radius: 8px; font-family: 'Bebas Neue'; 
          font-size: 22px; letter-spacing: 0.05em; box-shadow: 0 8px 25px rgba(0, 85, 255, 0.4);
          transition: transform 0.2s;
        }
        .glow-btn:hover { transform: translateY(-3px); }
      `}</style>

      {/* HERO SECTION */}
      <div style={{ background: 'radial-gradient(circle at top, #0A0D1A 0%, #020205 100%)', padding: '80px 20px', textAlign: 'center', borderBottom: '1px solid rgba(0, 229, 255, 0.1)' }}>
        <h1 className="hero-title" style={{ fontFamily: 'Bebas Neue' }}>
          TATA IPL <span style={{ color: '#00E5FF', textShadow: '0 0 20px rgba(0, 229, 255, 0.5)' }}>2026</span>
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 550, margin: '0 auto 40px', fontSize: 18 }}>
          Experience the thrill of the stadium. Book official tickets for the biggest T20 clashes of the season.
        </p>
        <Link to="/matches" className="glow-btn">
          VIEW SCHEDULE
        </Link>
      </div>

      {/* MATCHES SECTION */}
      <div className="container">
        <h2 style={{ fontFamily: 'Bebas Neue', fontSize: 36, marginBottom: 30, letterSpacing: '0.05em' }}>UPCOMING MATCHES</h2>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>
        ) : (
          <div className="match-grid">
            {matches.map(m => (
              <MatchCard key={m._id} match={m} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}